import { useCallback } from 'react';
import uuid from 'react-uuid';
import { MODELS_USER_GROUPS_KEY } from 'dashboard409a/pages/Workboard/common/constants';
import { UserGroup } from 'dashboard409a/pages/Workboard/UserGroups/UserGroups.types';
import { useLocalStorage } from 'services/hooks/useLocalStorage';

export const useUserGroups = () => {
  const [groups, setGroups] = useLocalStorage<UserGroup[]>(MODELS_USER_GROUPS_KEY, []);

  const createGroup = useCallback(
    (name: string, userIds: number[], isDefault: boolean) => {
      const newGroup: UserGroup = { id: uuid(), name, userIds, isDefault };
      setGroups(prev => {
        const updated = isDefault
          ? prev.map(g => ({ ...g, isDefault: false }))
          : prev;
        return [...updated, newGroup];
      });
      return newGroup;
    },
    [setGroups]
  );

  const updateGroup = useCallback(
    (updated: UserGroup): UserGroup => {
      setGroups(prev => {
        const withCleared = updated.isDefault
          ? prev.map(g => ({ ...g, isDefault: false }))
          : prev;
        return withCleared.map(g => (g.id === updated.id ? updated : g));
      });
      return updated;
    },
    [setGroups]
  );

  const deleteGroup = useCallback(
    (groupId: string) => {
      setGroups(prev => prev.filter(g => g.id !== groupId));
    },
    [setGroups]
  );

  const defaultGroup = groups.find(g => g.isDefault) ?? null;

  return { groups, defaultGroup, createGroup, updateGroup, deleteGroup };
};
